import { DataCard } from "./styles"


interface IDataCardComponentProps {
  icon?: JSX.Element
  number: string
  units: string
  subText?: string
  subTextDown?:string
  mainContainerStyle?: string
}
export const DataCardComponent = ({ icon, number, units, mainContainerStyle, subTextDown,subText }: IDataCardComponentProps) => {
  return (
    <DataCard data-testid='test-data-card' className={`${mainContainerStyle}`}>
      <div className='flex flex-col'>
        <span className='text-darkGray text-[28px] font-semibold pt-1'>{number || 0}</span>
        <span className='text-xs text-gray-700 text-opacity-80' >
          {subText}
        </span>
        <span className='text-base'>
          {units}
        </span>
        <span className='text-xs text-gray-700 text-opacity-80' >
          {subTextDown}
        </span>
    
        
      </div>
      {
        icon ?
          icon : null
      }
    </DataCard>
  )
}